import { atom } from "recoil"

export const notificationsRequestIdState = atom<number>({
  key: "atoms/home/notificationsRequestIdState",
  default: 0,
})
